import { render } from "./PeopleAlsoAsk.vue?vue&type=template&id=28ae2414"
import script from "./PeopleAlsoAsk.vue?vue&type=script&lang=js"
export * from "./PeopleAlsoAsk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__